<template>
  <div class="bgBox">
    <div class="conBox">
      <div class="fontBox">
        <div class="fontCon">
          <div class="conH3">{{ $fanyi("无限目录") }}</div>
          <div class="conH2">{{ $fanyi("数以百万计的认证产品") }}</div>
          <div class="conCon">
            {{
              $fanyi(
                "发现你的下一个商业机会！通过我们与1688.com的合作，访问全球最大的制造商目录。",
              )
            }}
          </div>
        </div>
      </div>
      <div class="goodsList flex flw jcenter">
        <div
          class="SearchConterCrosswiseCon"
          v-for="(item, index) in lists"
          :key="index"
          @click="
            isLogin
              ? $fun.toCommodityDetails(item.goods_id, item)
              : $store.commit('getshowLoginDialog', true)
          "
        >
          <!-- 放图片的div -->
          <div class="SearchConterCrosswiseImg">
            <!-- <img class="goodsImg" :src="item.imgUrl" /> -->
            <el-image :src="item.imgUrl" class="goodsImg">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
              <div slot="placeholder">
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
            <!-- <loadingImg :src="item.imgUrl" /> -->
          </div>
          <!-- 显示其他信息的div -->
          <div class="rests">
            <p class="goodsTitle" :title="item.title">
              <img
                src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20251017132103833880.svg"
                alt=""
                class="logoBox"
              />
              <span>
                {{ item.title }}
              </span>
            </p>
            <p class="flex acenter">
              <span
                >{{
                  $fun.EURNumSegmentation(
                    $fun.ceil(item.goodsPrice * $store.state.exchangeRate),
                  )
                }}€</span
              >
              <span>{{ $fun.RMBNumSegmentation(item.goodsPrice) }}￥</span>
            </p>
            <div class="totalTagBox" v-if="false">
              {{ $fanyi("每月销售") }}: {{ item.monthSold }} {{ $fanyi("件") }}
            </div>
            <div class="totalTagBox" v-if="false">
              {{ $fanyi("回购率") }}: {{ item.repurchaseRate }}%
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["show"],
  data() {
    return {
      lists: [],
    };
  },
  components: {},
  computed: {
    isLogin() {
      return !this.show;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$api.getHomeGoodsList().then((res) => {
        ////console.log('事件名',res)
        if (res.code != 0)
          return this.$message.error(this.$fanyi(res.data.msg));
        //接下来的操作
        // 把评分的数据转化为数值型;
        let shop_id = [];
        this.lists = [];

        this.lists = res.data.result;
      });
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";
.bgBox {
  padding: 56px 0;
}
.conBox {
  max-width: 1440px;
  margin: 0 auto;

  .fontBox {
    text-align: center;
    margin: 0 auto 72px;
    width: 820px;
    .conH3 {
      color: var(--Rakumart-500, #009246);
      font-size: 20px;
      font-weight: 700;
      line-height: 30px; /* 150% */
      margin-bottom: 8px;
    }
    .conH2 {
      color: #013b2d;

      font-size: 36px;
      font-weight: 600;
      line-height: 44px; /* 122.222% */
      letter-spacing: -0.72px;
      margin-bottom: 16px;
    }
    .conCon {
      font-size: 18px;
      line-height: 28px; /* 155.556% */
    }
  }

  .goodsList {
    gap: 24px;
    .SearchConterCrosswiseCon {
      position: relative;
      transition: 0.3s;
      background-color: white;
      width: 256px;
      height: 340px;
      border: solid 1px #e8e8e8;
      box-shadow: 0px 4px 8px -2px rgba(16, 24, 40, 0.1),
        0px 2px 4px -2px rgba(16, 24, 40, 0.06);

      border-radius: 16px;
      overflow: hidden;
      cursor: pointer;
      &:hover {
        transform: translate(0, -5px);
        box-shadow: 0px 10px 20px #d1d1d1;

        .similarProducts {
          opacity: 1;
        }
      }

      &:nth-child(5n) {
        margin-right: 0px;
      }

      .SearchConterCrosswiseImg {
        height: 256px;

        overflow: hidden;
        position: relative;

        > .goodsImg {
          background-color: transparent;
        }

        .el-image {
          transition: 0.3s;
          width: 260px;
          height: 260px;
        }
      }

      .rests {
        box-sizing: border-box;
        padding: 16px;

        p {
          font-size: 12px;

          font-weight: 400;
          color: #000000;

          &.goodsTitle {
            height: 23px;
            font-size: 16px;
            font-weight: 600;
            display: flex;
            align-items: center;

            .logoBox {
              margin-right: 4px;
              vertical-align: middle;
            }
            span {
              @extend .text-overflow-one;
            }
          }

          &:nth-child(2) {
            font-size: 18px;
            color: #667085;
            align-items: center;
            font-weight: 700;
            line-height: 28px;
            span:first-child {
              color: #009246;
              margin-right: 8px;
            }
          }

          .collect {
            display: flex;
            align-items: center;

            img {
              width: 20px;
              height: 20px;
              margin-right: 10px;
            }

            span {
              font-size: 14px;

              color: #888888;
              line-height: 20px;
            }
          }
        }
        .totalTagBox {
          @extend .text-overflow-one;
          border-radius: 6px;
          border: 1px solid var(--Rakumart-300, #bddbb8);
          background: var(--Rakumart-50, #eaf8e8);
          font-size: 13px;
          color: #009246;
          font-weight: 600;
          line-height: 24px;
          margin-bottom: 8px;
          padding-left: 4px;
          &:last-child {
            margin-bottom: 0px;
          }
        }
      }
    }
  }
}
</style>
